<template>
    <div>
        <forms-vue
            v-bind:title="title"
            v-bind:form="form"
            v-bind:submit_url="submit_url"
            v-bind:redirect_submit_url="redirect_submit_url"
            v-bind:redirect_submit_url_params="redirect_submit_url_params"
            v-bind:edit_get_url="edit_get_url"
            v-bind:watch="watch"
            v-bind:submit_in_url="submit_in_url"
        ></forms-vue>
    </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
    data() {
        return {
            title: "Configuraciones - Numeración",
            submit_url: this.$route.fullPath+"/save",
            redirect_submit_url: "NumeracionSearch",
            redirect_submit_url_params: {},
            edit_get_url: "",
            submit_in_url: false,
            items: [],
            watch: [],
            form: [
                [
                    {
                        col: "12",
                        title: "Datos Generales	",
                        footer: {},
                        attrs: [
                            [
                                {
                                    pretty_name: "Codigo",
                                    name: "codigo",
                                    desc: "select",
                                    type: "text",
                                    cols: "12",
                                },
                                {
                                    pretty_name: "Descripción",
                                    name: "descripcion",
                                    desc: "select",
                                    type: "text",
                                    cols: "12",
                                },
                                {
                                    pretty_name: "Estado",
                                    name: "estado",
                                    desc: "select",
                                    type: "select",
                                    cols: "12",
                                    options: [
                                        { label: "Activo", code: "A" },
                                        { label: "Dado de baja", code: "B" },
                                    ],
                                }
                            ],
                        ],
                        footer: {
                            buttons: [
                                {
                                    type: "button",
                                    text: "Cancelar",
                                    class: "btn btn-danger pull-left",
                                    route: "NumeracionSearch",
                                },
                                {
                                    type: "submit",
                                    text: "Guardar",
                                    class: "btn btn-success pull-right",
                                    route: "NumeracionSearch",
                                },
                            ],
                        },
                    },
                ],
            ],
        };
    },
    computed: {},
    methods: {},
    mounted() {},
    created() {

    },
};
</script>
